import { render, staticRenderFns } from "./ModuleTrainersList.vue?vue&type=template&id=44fe3f82&scoped=true&lang=pug&"
import script from "./ModuleTrainersList.vue?vue&type=script&lang=js&"
export * from "./ModuleTrainersList.vue?vue&type=script&lang=js&"
import style0 from "./ModuleTrainersList.vue?vue&type=style&index=0&id=44fe3f82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fe3f82",
  null
  
)

export default component.exports